import { Typography, styled } from '@gogame/components';

export const MarkdownContainer = styled(Typography)`
  font: 14px Roboto, Helvetica, Arial, sans-serif;
  line-height: 2;

  strong {
    font-weight: 500;
  }

  a {
    color: ${(props) => props.theme.palette.primary.main};
    text-decoration: none;
  }
  ul,
  ol {
    margin: 8px 0;
  }
`;
